// export const ApiPath = "http://localhost:3000/"

export const ApiPath = "https://pagoanalytics.azurewebsites.net/"

export const googleMapAPI = "AIzaSyACbEJThhqjXiiOtZiogD2I77RFO2Q5uFM"
// export const googleMapAPI = "AIzaSyAdkoYYorJ9XICIk4pcAKmvjc1dd1gMWgo"

export const ApiPathCareers = "https://pagoanalytics.azurewebsites.net/jaavapotcareers"

export const ApiPathQuiz = "https://pagoanalytics.azurewebsites.net/jaavapotquiz/quiz/"